import React from 'react';

const Footer = ({ user }) => {
  return (
    <React.Fragment>
      <footer className="sticky-footer bg-white">
        <div className="container my-auto">
          <div className="copyright text-center my-auto">
            <span>Copyright &copy; Jeroid 2020. </span>
            All Rights Reserved.
          </div>
        </div>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
